module.exports = __webpack_public_path__ + "static/media/fading_light.f76d1299.jpg";